$(function () {
	var marquee = $('.banner-next-scrolling .title-scrolling');
	marquee.each(function (i) {
		$(this).marquee(i, false);
	});

	var pageTitle = $('.banner-hero h1.title-scrolling');
	pageTitle.each(function () {

		// scope for page title if exists
		var $this = $(this);  // define parent elem
		
		if ($this.hasClass("multi")) {

			$this.marquee(0, true);
		
		} else {
			var titleText = $(this).text(),  // remember original title text
				demo = $('<strong>');  // create elem to test width
			// Replace existing title text with demo element
			demo.text(titleText);
			$this.empty();
			$this.append(demo);
			// Test if demo element is wider than the parent
			if (demo.width() > $this.width()) {
				// Word is overflowing; 
				// so revert to original markup
				// and initiate the scrolling effect

				$this.empty();
				$this.text(titleText);
				$this.marquee(0);
				$this.css("white-space", "nowrap")

			} else {
				// Word not overflowing;
				// Revert to original markup
				$this.empty();
				$this.text(titleText);
			}
		}

		$this.css("white-space", "nowrap");

	});

	var fitBanner = $('.banner-hero,.fit-height');
	function bannerHeight() {
		
		var h = winH - $('#header-gbl').outerHeight(),
			dif = 30,
			type = 'height';
		$('.opening-hours-d').each(function () {
			dif = 0.5 * $(this).find('main').height();
		});
		if (fitBanner.is('.tour-header')) {
			$(fitBanner).css({ "min-height": ($(fitBanner).find(".inner").outerHeight() + 100) })
		} else {
			fitBanner.css(type, h - dif);
		}
	}

	$('#header-gbl img:first').bind('load', bannerHeight);
	$(window).on('resize', bannerHeight);
});